<template>
	<a
		:href="href"
		@click.prevent="handleClick"
		@mousedown="$emit('mouseDown')"
		:class="btnClassses"
	>
		<slot />
	</a>
</template>

<script>
export default {
	name: 'VButton',
	props: {
		fullWidth: {
			type: Boolean,
			default: false
		},
		href: {
			type: String,
			default: '#'
		},
		size: {
			type: String,
			default: 'md'
		},
		active: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		theme: {
			type: String,
			default: ''
		},
		stop: {
			type: Boolean,
			default: false
		}
		// @clickHandler
	},
	computed: {
		btnClassses() {
			return `btn btn-${this.size} ${this.disabled ? 'disabled' : ''} ${this.fullWidth ? 'w-100' : ''} ${this.active ? 'active' : ''} ${this.theme}`
		}
	},
	methods: {
		handleClick(event) {
			if (this.stop) { event.stopPropagation() }
			
			this.$emit('clickHandler')
		}
	}
}
</script>

<style scoped lang="scss">
.btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 9px 16px;
	transition: background-color .3s, color .3s, border-color .3s;
	text-align: center;
	font-size: 16px;
	font-weight: 400;
	min-height: 38px;
	line-height: 17.64px;
	text-transform: capitalize;
	background: var(--primary-btn);
	border: 1px solid var(--outline);
	color: var(--primary-text);
	border-radius: 10px;

	&:hover {
		border-color: var(--outline);
		background-color: var(--primary-btn-hover);
	}

	&.active {
		background: var(--accent);
		color: #ffffff;
		border: none;

		&:hover {
			background-color: var(--secondary-btn-hover);
		}
	}

	&.orange {
		background: #4D4D4D;
		color: $orange-text;
		border: none;

		&:hover {
			background: var(--delete-btn);
			color: #fff;
		}

		&.active {
			background: var(--delete-btn);
			color: #fff;
			
			&:hover {
				background: var(--delete-btn-hover);
				color: #fff;
			}
		}
	}

	&.disabled {
		pointer-events: none;
		user-select: none;
		opacity: .6;
	}

	&.w-100 {
		width: 100%;
	}

	&.secondary {
		color: #717171;
	}

	&.btn-xs {
		font-size: 14px;
		padding: 4px 9px;
	}

	i {
		pointer-events: none;
	}
}
</style>
